import { THead, TR, TH, TD, Div, Span, A, not, all } from 'alkali'

import { ERow } from 'services/extract/types'
import { ExtractionComparison } from 'components/extract/model/comparison'
import * as _ from 'lodash'
import * as pluralize from 'pluralize'

const rowToStr = (o, rowSection) => (o.outcome?.term?.label || rowSection) + (o.timepoint?.val ? ` @${o.timepoint.val}` : '')
const groupToStr = g => g.OriginalName + (g.N ? ` (${g.N})` : '')

const rowStatus = (outcome, comparison, rowSection) =>
	all([outcome, comparison], (outcome: ERow, { comparisons }: ExtractionComparison) => {
		const uneditable = comparisons.filter(c => c.row.id == outcome.id && c.uneditable)
		const cellgroups = uneditable.flatMap(c => {
			const ids = c.matchingCells.map(m => m.cell.group)
			return c.groupMatch.matches.filter(m => ids.includes(m.match.Id)).map(m => m.match)
		})
		//const groups = _.uniq(_.compact(uneditable.flatMap(c => (c.matchingCells || []).map(c => c.group).filter(g => !isRapidExtract(g)))))
		const groups = _.uniq(_.compact(cellgroups))
		if (groups.length > 0) {
			return rowToStr(outcome, rowSection) +
				` already extracted for existing ${pluralize('group', groups.length)}: ` + groups.map(groupToStr).join(', ')
		}
	})

export default class RowHead extends THead {
	created(props) {
		const { row, rowComponent, rowColSpan = 1, activeIndex, summary, comparison, rowTypeTitle = 'Row' } = props
		const status = rowStatus(row, comparison, rowTypeTitle)
		const timepointCols = 3
		const allCols = all([rowColSpan, timepointCols], (cols1, cols2) => cols1 + 1 /*studyn*/ + cols2)
		props.content = [
			TR('.header-row', [
				TH({ attributes: { scope: 'col' }, title: rowTypeTitle }),
				TH('.outcome-hdr', { attributes: { scope: 'col', colspan: rowColSpan } }, rowTypeTitle),
				TH('.study-n-hdr', { attributes: { scope: 'col' } }, 'Study N'),
				TH('.timepoint-hdr', { attributes: { scope: 'col', colspan: timepointCols } }, 'Followup'),
			]),
			TR([
				TD('.spacer-row'),
				TD({ attributes: { scope: 'col', colspan: rowColSpan } }),
				TD('.study-n-cell'),
				TD({ attributes: { scope: 'col', colspan: timepointCols } })
			]),
			TR([
				TH('.outcome-row-hdr', [
					rowComponent.statusIcon
				]),
				TD('.outcome-cell', { attributes: { scope: 'col', colspan: rowColSpan } }, [
					Div([
						rowComponent,
						Div('.outcome-comparison', { hidden: not(status) }, status.to(s => [Span(s)]))
					])
				]),
				TD('.study-n-cell', [
					A({
						title: 'Edit Study N',
						onclick(e) {
							e.stopPropagation()
							activeIndex.put(0)
						},
						content: summary.abstractSource.N.to(n => (n || 'edit') + '')
					})
				]),
				TD('.timepoint-cell', { attributes: { scope: 'col', colspan: timepointCols } },
					rowComponent.timepoint
				)
			]),
			rowComponent.optionsPanel ? TR('.row-options-row', { classes: { hidden: not(rowComponent.optionsVisible) } }, [
				TH(),
				TD({ attributes: { colspan: allCols } }, [rowComponent.optionsPanel])
			]) : undefined,
			TR([TD('.spacer-row')])
		]
	}
}
